import * as React from 'react';

import { Typography } from 'antd';

import type { AddressFormKit } from 'v2/interfaces/addressKit';

type AddressToDeliveryKitProps = {
  address: AddressFormKit;
};

function formatZipCode(zipCode: string) {
  return zipCode
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
}

const AddressToDeliveryKit = (props: AddressToDeliveryKitProps) => {
  const { city, neighborhood, number, state, street, zipcode }: AddressFormKit = props.address;
  return (
    <Typography.Text>
      {`${street}, ${number ?? 'sem número'}, ${neighborhood}, ${city}/${state} - CEP ${formatZipCode(zipcode)}`}
    </Typography.Text>
  );
};

export default AddressToDeliveryKit;
